import { QTYPES } from '@nexxt/common/types';

export const GROUP_QTYPES = [QTYPES.GROUP, QTYPES.POPUP];

export const AUDIENCE_QTYPE = [
    QTYPES.MULTIMEDIA,
    QTYPES.MULTIPLE_CHOICE,
    QTYPES.SINGLE_CHOICE,
    QTYPES.ICONS,
    QTYPES.RANK_ORDER,
    QTYPES.SCALE,
    QTYPES.LANGUAGE,
    QTYPES.VECTOR_MAP,
    QTYPES.VIRTUAL,
    QTYPES.NUMERIC,
    QTYPES.SPECIALS,

    QTYPES.SYSTEM_METADATA,
    QTYPES.PANEL,
    QTYPES.LANGUAGE,
    QTYPES.DEVICE
];

export const DEV_QTYPES = [
    QTYPES.DEPARTING_MESSAGE,
    QTYPES.GREETING_TEXT,
    QTYPES.AD_BUILDER,
    QTYPES.REDIRECT,
    QTYPES.RANDOMIZER,
    QTYPES.MULTI_TARGETS // only for dash...
];

export const IN_PROGRESS_QTYPES = [
    QTYPES.SFA,
    QTYPES.AD_BUILDER,
    QTYPES.RANDOMIZER,
    QTYPES.HOT_AIR_BALLOON
];

export const TEXT_REFERENCE_QTYPES = [
    QTYPES.OPEN,
    QTYPES.NUMERIC,
    QTYPES.MULTIPLE_CHOICE,
    QTYPES.SINGLE_CHOICE,
    QTYPES.RANK_ORDER,
    QTYPES.SCALE,
    QTYPES.POPUP_CARD,
    QTYPES.MULTI_POPUP_CARD,
    QTYPES.TRADE_OFF,
    QTYPES.NPS,
    QTYPES.ICONS,
    QTYPES.VECTOR_MAP,
    QTYPES.VIRTUAL, // note: uses label, not text!

    //SYSTEM QTYPES
    QTYPES.LANGUAGE,
    QTYPES.DEVICE,
    QTYPES.SPECIALS,
    QTYPES.URL_METADATA,
    QTYPES.SYSTEM_METADATA
];

export const CONDITION_QTYPES = [
    // Regular inca logic
    QTYPES.SINGLE_CHOICE,
    QTYPES.MULTIPLE_CHOICE,
    QTYPES.SCALE,
    QTYPES.RANK_ORDER,
    QTYPES.POPUP_CARD,
    QTYPES.MULTI_POPUP_CARD,
    QTYPES.RATE_IMAGE,
    QTYPES.TRADE_OFF,
    QTYPES.VIRTUAL,
    QTYPES.SPECIALS,
    QTYPES.LANGUAGE,
    QTYPES.ICONS,
    QTYPES.VECTOR_MAP,
    QTYPES.OPEN,
    QTYPES.NUMERIC,
    QTYPES.NPS,

    // For BASIC - only isDisplayed/isNotDisplayed
    QTYPES.MULTIMEDIA,
    QTYPES.HOTSPOT,
    QTYPES.NPS,
    QTYPES.VIDEO_ANNOTATION,
    QTYPES.TREEMAN,
    QTYPES.TEXT_HIGHLIGHTER,
    QTYPES.GUIDED_FANTASY,
    QTYPES.JOURNEY,
    QTYPES.RAPID_CHOICE,

    //SYSTEM QTYPES
    QTYPES.LANGUAGE,
    QTYPES.DEVICE,
    QTYPES.SPECIALS,
    QTYPES.URL_METADATA,
    QTYPES.SYSTEM_METADATA
];

export const PIPING_OPTION_QTYPES = [
    QTYPES.MULTIPLE_CHOICE,
    QTYPES.SINGLE_CHOICE,
    QTYPES.RANK_ORDER,
    QTYPES.VIRTUAL,
    QTYPES.POPUP_CARD,
    QTYPES.MULTI_POPUP_CARD
];

export const MULTIPLE_ANSWER_TYPES = [
    QTYPES.MULTIPLE_CHOICE,
    QTYPES.MULTI_POPUP_CARD,
    QTYPES.RANK_ORDER
];

export const SYSTEM_METADATA_QTYPES = [
    QTYPES.DEVICE,
    QTYPES.LANGUAGE,
    QTYPES.PANEL
];
